import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import * as PropTypes from 'prop-types'

const useStyles = createUseStyles(
  {
    loading: {
      minHeight: '60vh',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      display: 'flex'
    }
  },
  { name: 'kinan-' }
)

export const Loading = (props) => {
  const { className, minHeight, size, style, ...rest } = props
  const classes = useStyles()

  return (
    <div
      className={classes.loading}
      style={{
        minHeight: minHeight
      }}>
      <CircularProgress
        style={{ width: size, height: size }}
        className="text-color"
      />
    </div>
  )
}

Loading.propTypes = {
  minHeight: PropTypes.string,
  size: PropTypes.string
}

Loading.displayName = 'l'

export default Loading
